// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"adecdfca","906":"adecdfca","919":"0a484b98"}[chunkId] + ".chunk.css";
};